const CHECKOUT_IDEMPOTENCY_STORAGE_KEY = 'cartCheckoutIdempotencyKey';

export function generateCheckoutIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function getStoredCheckoutIdempotencyKey(): string | null {
  try {
    const raw = sessionStorage.getItem(CHECKOUT_IDEMPOTENCY_STORAGE_KEY);
    if (!raw) return null;
    const trimmed = raw.trim();
    return trimmed.length > 0 && trimmed.length <= 128 ? trimmed : null;
  } catch {
    return null;
  }
}

export function ensureCheckoutIdempotencyKey(existing: string | null): string {
  const stored = existing?.trim() || getStoredCheckoutIdempotencyKey();
  if (stored) {
    return stored;
  }

  const key = generateCheckoutIdempotencyKey();
  try {
    sessionStorage.setItem(CHECKOUT_IDEMPOTENCY_STORAGE_KEY, key);
  } catch {
    // sessionStorage unavailable — in-memory only
  }
  return key;
}

export function clearCheckoutIdempotencyKey(): void {
  try {
    sessionStorage.removeItem(CHECKOUT_IDEMPOTENCY_STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Treat Processing like Pending wherever checkout order status is shown. */
export function isCheckoutOrderInProgress(status: string | null | undefined): boolean {
  if (!status) return false;
  return status === 'Pending' || status === 'Processing';
}

export function formatCheckoutOrderStatus(status: string | null | undefined): string {
  if (!status) return 'Unknown';
  if (status === 'Processing') return 'Pending';
  return status;
}
